import React from 'react'
import PropTypes from 'prop-types'
import { Text, Button, Flex, Box } from '@chatterbug/aaron'
import { Modal } from '@chatterbug/aaron/modal'

import { t } from 'src/lib/i18n-react'

import { customModalStyle } from '../utils'

const ConfirmationModal = ({
  isOpen,
  title,
  message,
  content,
  confirmButtonLabel = 'OK',
  confirmButtonDisabledWithLabel,
  onConfirm = () => {},
  onHide = () => {},
  showButtons = true,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      title={title}
      onRequestClose={onHide}
      style={customModalStyle}
    >
      <Flex flexDirection="column">
        <Text
          mb="4x"
          textAlign="center"
          maxWidth={500}
          data-testid="confirmation-modal-message"
        >
          {message}
        </Text>
        {content && <Box mb="4x">{content}</Box>}
        {/* if we are asking for payment details then we are showing the button from the payment form, these ones are redundant */}
        {showButtons && (
          <Flex
            justifyContent="flex-end"
            alignItems="center"
            pt="2x"
            borderTopWidth="1px"
            borderTopStyle="solid"
            borderTopColor="gray88"
          >
            <Button
              onClick={onHide}
              style={{
                backgroundColor: 'white',
                color: '#95989D', //gray60
                marginRight: '16px',
              }}
            >
              {t('Cancel')}
            </Button>
            <Button
              onClick={() => onConfirm()}
              disableWith={confirmButtonDisabledWithLabel}
              type="primaryAdvanced"
              data-testid="confirm-button"
            >
              {confirmButtonLabel}
            </Button>
          </Flex>
        )}
      </Flex>
    </Modal>
  )
}

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  content: PropTypes.any,
  confirmButtonDisabledWithLabel: PropTypes.string,
  confirmButtonLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  onHide: PropTypes.func,
  showButtons: PropTypes.bool,
}

export default ConfirmationModal
